import { render, staticRenderFns } from "./BaseDropdownSelect.vue?vue&type=template&id=e2268aea&scoped=true&"
import script from "./BaseDropdownSelect.vue?vue&type=script&lang=js&"
export * from "./BaseDropdownSelect.vue?vue&type=script&lang=js&"
import style0 from "./BaseDropdownSelect.vue?vue&type=style&index=0&id=e2268aea&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2268aea",
  null
  
)

export default component.exports